import { createAction, handleActions } from 'redux-actions';
import * as R from 'ramda';

export const pages = {
  list: 'LIST',
  form: 'FORM',
};

export const types = {
  bowlersListLoad: 'BOWLERS_LIST_LOAD',
  bowlersListLoaded: 'BOWLERS_LIST_LOADED',
  bowlerHandleForm: 'BOWLER_HANDLE_FORM',
  bowlerSet: 'BOWLER_SET',
  bowlerSetPhoto: 'BOWLER_SET_PHOTO',
  bowlerSetSignature: 'BOWLER_SET_SIGNATURE',
  bowlerError: 'BOWLER_ERROR',
  bowlerSaved: 'BOWLER_SAVED',
  bowlersChangePage: 'BOWLERS_CHANGE_PAGE',
  bowlersSearch: 'BOWLERS_SEARCH',
  bowlerSelect: 'BOWLER_SELECT',
  bowlerAddNew: 'BOWLER_ADD_NEW',
  bowlerRemove: 'BOWLER_REMOVE',
  bowlerTakePhoto: 'BOWLER_TAKE_PHOTO',
  bowlerGalleryPhoto: 'BOWLER_GALLERY_PHOTO',
  bowlerRemovePhoto: 'BOWLER_REMOVE_PHOTO',
  bowlerSavePhoto: 'BOWLER_SAVE_PHOTO',
  bowlerPhotoSaved: 'BOWLER_PHOTO_SAVED',
};

export const bowlersListLoad = createAction(types.bowlersListLoad);

export const bowlersListLoaded = createAction(types.bowlersListLoaded);

export const bowlerHandleForm = createAction(types.bowlerHandleForm);

export const bowlerSet = createAction(types.bowlerSet);

export const bowlerSetPhoto = createAction(types.bowlerSetPhoto);

export const bowlerSetSignature = createAction(types.bowlerSetSignature);

export const bowlerSelect = createAction(types.bowlerSelect);

export const bowlerError = createAction(types.bowlerError);

export const bowlerSaved = createAction(types.bowlerSaved);

export const bowlersChangePage = createAction(types.bowlersChangePage);

export const bowlersSearch = createAction(types.bowlersSearch);

export const bowlerAddNew = createAction(types.bowlerAddNew);

export const bowlerRemove = createAction(types.bowlerRemove);

export const bowlerTakePhoto = createAction(types.bowlerTakePhoto);

export const bowlerGalleryPhoto = createAction(types.bowlerGalleryPhoto);

export const bowlerRemovePhoto = createAction(types.bowlerRemovePhoto);

export const bowlerSavePhoto = createAction(types.bowlerSavePhoto);

export const bowlerPhotoSaved = createAction(types.bowlerPhotoSaved);

export const INITIAL_STATE = {
  loading: false,
  saving: false,
  bowlers: [],
  currentPage: pages.list,
  error: null,
  searchText: '',
  bowler: {},
};

export const bowlersReducer = handleActions(
  {
    [types.bowlersListLoad]: state => ({
      ...state,
      loading: true,
    }),
    [types.bowlersListLoaded]: (state, action) => ({
      ...state,
      bowlers: [...action.payload.bowlers],
      loading: false,
    }),
    [types.bowlerHandleForm]: state => ({
      ...state,
      saving: true,
    }),
    [types.bowlerSet]: (state, action) => ({
      ...state,
      bowler: R.merge(state.bowler)(action.payload.bowler),
    }),
    [types.bowlerSetSignature]: (state, action) => ({
      ...state,
      bowler: { ...state.bowler, signature: action.payload.signature },
    }),
    [types.bowlerSelect]: (state, action) => ({
      ...state,
      bowler: action.payload.bowler ? { ...action.payload.bowler } : {},
      currentPage: action.payload.noChangePage ? state.currentPage : pages.form,
    }),
    [types.bowlerSaved]: state => ({
      ...state,
      saving: false,
    }),
    [types.bowlerError]: (state, action) => ({
      ...state,
      error: action.payload.error,
      saving: false,
    }),
    [types.bowlersChangePage]: (state, action) => ({
      ...state,
      currentPage: action.payload.page,
    }),
    [types.bowlerPhotoSaved]: (state, action) => ({
      ...state,
      bowler: { ...state.bowler, photo: action.payload.photo },
    }),
    [types.bowlerRemovePhoto]: state => ({
      ...state,
      bowler: { ...state.bowler, photo: null },
    }),
    [types.bowlerRemove]: (state, action) => ({
      ...state,
      bowlers: state.bowlers.filter(bowler => bowler.id !== action.payload.bowler.id),
    }),
    [types.bowlersSearch]: (state, action) => ({
      ...state,
      searchText: action.payload.searchText,
    }),
  },
  INITIAL_STATE
);
